import React, { useContext, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import WizardStateContext from 'components/Wizards/shared/context/wizardstate';
import Switch from 'components/Kizen/Switch';
import {
  DashboardStyleSettingsProvider,
  DashboardStyleSettings,
  DEFAULT_DASHLET_STYLE_SETTINGS,
} from 'ts-components/StyleSettings';
import { StyledWizardField } from 'components/Wizards/shared/styles';
import { REPORT_TYPES } from 'components/Wizards/Dashlet/types';
import { useVizCatColors } from 'pages/Dashboard/components/useVizCatColors';

const settingsExist = (settings) => Object.keys(settings).length > 0;
const withChartTheme = (settings, defaultChartTheme) => ({
  ...settings,
  chartTheme: settings.chartTheme ?? defaultChartTheme,
});
const StyleDisplaySettings = ({ defaultSettings }) => {
  const intialRender = useRef(true);
  const { t } = useTranslation();
  const defaultChartTheme = useVizCatColors();
  const { state, setState } = useContext(WizardStateContext.Context);
  const { dashletStyleConfig, customStylesEnabled, reportType } = state;

  const hideChartTheme = [
    REPORT_TYPES.SCHEDULED_ACTIVITIES,
    REPORT_TYPES.SCHEDULED_ACTIVITIES_CALENDAR,
  ].includes(reportType?.value);
  if (
    settingsExist(defaultSettings) &&
    (!dashletStyleConfig || !settingsExist(dashletStyleConfig)) &&
    customStylesEnabled !== false &&
    intialRender.current
  ) {
    intialRender.current = false;
    setState(
      'dashletStyleConfig',
      withChartTheme(defaultSettings, defaultChartTheme)
    );
  }

  const handleToggle = useCallback(
    (event) => {
      setState('customStylesEnabled', event.target.checked);
      if (event.target.checked && settingsExist(defaultSettings)) {
        setState(
          'dashletStyleConfig',
          withChartTheme(defaultSettings, defaultChartTheme)
        );
      } else if (event.target.checked) {
        setState('dashletStyleConfig', {
          ...DEFAULT_DASHLET_STYLE_SETTINGS,
          chartTheme: defaultChartTheme,
        });
      } else {
        setState('dashletStyleConfig', undefined);
      }
    },
    [defaultSettings, setState, defaultChartTheme]
  );

  return (
    <>
      <StyledWizardField fullWidth top={20}>
        <Switch
          data-qa="customize-styles-toggle"
          checked={customStylesEnabled}
          textPlacement="regular-top"
          label={t('Customize Styles')}
          onClick={handleToggle}
        />
      </StyledWizardField>
      {customStylesEnabled ? (
        <DashboardStyleSettingsProvider
          styleSettings={dashletStyleConfig ?? defaultSettings}
        >
          <DashboardStyleSettings
            onChange={(settings) => setState('dashletStyleConfig', settings)}
            hideChartTheme={hideChartTheme}
          />
        </DashboardStyleSettingsProvider>
      ) : null}
    </>
  );
};

export default StyleDisplaySettings;
